import { Icon } from "@trueskin-web/components"
import { checkPolygonIcon } from "@trueskin-web/theme/icons/checkPolygonIcon"

const RecommendedLabel = ({ className }) => {
  return (
    <div
      sx={{
        height: "24px",
        px: 2,
        color: "white",
        fontSize: 0,
        lineHeight: "smallerHeading",
        bg: "primary",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
      }}
      className={className}
    >
      Patient:innen-Liebling
      <Icon icon={checkPolygonIcon} size="sm" sx={{ ml: 1 }} />
    </div>
  )
}

export default RecommendedLabel
